import React from 'react'
import { BookIcon } from '@frontend/pole-ui/lib/components/Icon/svg/BookIcon'
import { CartIcon } from '@frontend/pole-ui/lib/components/Icon/svg/CartIcon'
import { CoinsIcon } from '@frontend/pole-ui/lib/components/Icon/svg/CoinsIcon'
import { PhoneCallIcon } from '@frontend/pole-ui/lib/components/Icon/svg/PhoneCallIcon'
import { ProfileIcon } from '@frontend/pole-ui/lib/components/Icon/svg/ProfileIcon'
import { ScaleIcon } from '@frontend/pole-ui/lib/components/Icon/svg/ScaleIcon'
import { SellIcon } from '@frontend/pole-ui/lib/components/Icon/svg/SellIcon'
import { WheatBoldIcon } from '@frontend/pole-ui/lib/components/Icon/svg/WheatBoldIcon'
import { EAgriculturalProductsRoute, EFinancingOfferRoute, EHarvestSaleRoute, EJournalRoute, EUserProfileRoute } from '@/types'
import { EOfferRequestsRoute } from '@/types/EOfferRequestsRoute'
import { getUrlWithQuery } from '@/utils/url'
import { ENavLink, type NavLink } from './interfaces'
import { messages } from './messages'

export const links: NavLink[] = [
  {
    id: ENavLink.FERTILIZERS,
    text: messages.menu.link.fertilizers,
    url: EAgriculturalProductsRoute.main,
    icon: <CartIcon />,
  },
  {
    id: ENavLink.FINANCING,
    text: messages.menu.link.financing,
    url: EFinancingOfferRoute.main,
    icon: <SellIcon />,
    subLinks: [
      {
        id: ENavLink.FINANCING_MONEY,
        text: messages.menu.link.financingItems.money.title,
        subText: messages.menu.link.financingItems.money.subText,
        icon: <SellIcon />,
        url: EFinancingOfferRoute.MFOPage,
        isAccent: true,
      },
      {
        id: ENavLink.FINANCING_CONSULT,
        text: messages.menu.link.financingItems.consult.title,
        subText: messages.menu.link.financingItems.consult.subText,
        icon: <PhoneCallIcon />,
        url: EFinancingOfferRoute.main,
      },
      {
        id: ENavLink.FINANCING_SELF,
        text: messages.menu.link.financingItems.self.title,
        subText: messages.menu.link.financingItems.self.subText,
        icon: <CoinsIcon />,
        url: EFinancingOfferRoute.main,
      },
    ],
  },
  {
    id: ENavLink.HARVEST_SALE,
    text: messages.menu.link.harvestSale,
    url: EHarvestSaleRoute.main,
    icon: <WheatBoldIcon />,
  },
  {
    id: ENavLink.PRICE_REQUESTS,
    text: messages.menu.link.priceRequests,
    url: getUrlWithQuery(EOfferRequestsRoute.main, { offset: 0 }),
    icon: <ScaleIcon />,
  },
  {
    id: ENavLink.JOURNAL,
    text: messages.menu.link.journal,
    url: EJournalRoute.MAIN,
    icon: <BookIcon />,
  },
]

export const mobileLinks: NavLink[] = [
  {
    id: ENavLink.PROFILE,
    text: messages.menu.link.profile,
    url: EUserProfileRoute.main,
    icon: <ProfileIcon />,
  },
  ...links,
]
